var map = {
	"./Alchimeia_island.png": "02ec",
	"./Fabella_island.png": "804d",
	"./Lumina_island.png": "68dd",
	"./Morbida_island.png": "2694",
	"./Oracle_island.png": "b702",
	"./Sylva_island.png": "bad7",
	"./Temperus_island.png": "7951",
	"./Veritas_island.png": "9818"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2f9";